export default "__VITE_ASSET__CvPzQmnO__"